// removed by extract-text-webpack-plugin
module.exports = {"button":"button__17M3h"};


//////////////////
// WEBPACK FOOTER
// ./components/userMenu/style.css
// module id = 9j6v
// module chunks = 6